// extracted by mini-css-extract-plugin
module.exports = {"task":"Task_task__l1tbg","isDone":"Task_isDone__2ywXY"};